var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagetitle"},[_c('Container',[(_vm.breadcrumbs)?_c('bread-crumbs',{attrs:{"list":_vm.breadcrumbs}}):_vm._e(),_c('h1',{staticClass:"pagetitle__label"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }